var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 30 36"}},[_c('polygon',{attrs:{"points":"0 0 0 36 30 18 0 0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }